export const DR_RESET = "DR_RESET";
export const DR_SET_ERROR = "DR_SET_ERROR";
export const DR_SET_ITEMS = "DR_SET_ITEMS";
export const DR_TOGGLE_LOADING = "DR_TOGGLE_LOADING";
